/* AIKO — shared behaviors. Cargar: {{ 'aiko.js' | asset_url | script_tag }} (o defer) */
(function () {
  // Reveal on scroll
  function initReveal() {
    var els = document.querySelectorAll('.aiko-reveal');
    if (!('IntersectionObserver' in window) || !els.length) {
      els.forEach(function (e) { e.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: .12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  // FAQ accordion
  function initFaq() {
    document.querySelectorAll('[data-aiko-faq]').forEach(function (item) {
      var btn = item.querySelector('[data-aiko-faq-btn]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  // Sticky ATC: show after hero leaves viewport
  function initSticky() {
    var bar = document.querySelector('[data-aiko-sticky]');
    if (!bar) return;
    var trigger = document.querySelector('[data-aiko-sticky-trigger]') ||
      document.querySelector('.aiko-hero');
    if (!trigger || !('IntersectionObserver' in window)) { bar.classList.add('is-visible'); return; }
    var io = new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { threshold: 0 });
    io.observe(trigger);
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  ready(function () { initReveal(); initFaq(); initSticky(); });
  document.addEventListener('shopify:section:load', function () { initReveal(); initFaq(); initSticky(); });
})();
